import { FilledTextFieldProps, MenuItem } from '@mui/material';
import { SxProps } from '@mui/system';
import { forwardRef } from 'react';

import { InputField } from './input-field';

interface Option {
  color?: string;
  label: string;
  value: string;
}

interface Props extends Omit<FilledTextFieldProps, 'onClick' | 'variant'> {
  options: Option[];
  value: string;
  label?: string;
  onClick?: (value: string) => void;
  fullWidth?: boolean;
  sx?: SxProps;
}

export const Select = forwardRef<HTMLInputElement, Props>(
  ({ options, onClick, value, label, fullWidth = false, sx, ...rest }, ref) => {
    return (
      <InputField
        {...rest}
        sx={sx}
        label={label}
        placeholder={label}
        fullWidth={fullWidth}
        select
        value={value}
        ref={ref}>
        {options.map((option, i) => (
          <MenuItem
            key={i}
            sx={{
              alignItems: 'center',
              display: 'flex',
            }}
            value={option.value}
            onClick={() => onClick?.(option.value)}>
            {option.label}
          </MenuItem>
        ))}
      </InputField>
    );
  },
);

Select.displayName = 'Select';
